import React from 'react';
import styled from 'styled-components';

import Dropdown from '@/layout/components/Header/components/Dropdown';
import { HeaderVariables } from '@/layout/components/Header/constants';
import MenuColumn from '@/layout/components/Header/components/MenuColumn';
import useSettingItem from '@/hooks/useSettingItem';
import { colors } from '@/constants/theme';
import InfoLink from '@/layout/components/Header/components/InfoLink';

import { ServiceDropdownProps } from './types';

function ServiceDropdown({ menuItem }: ServiceDropdownProps) {
  const headerServices = useSettingItem('HEADER_SERVICES');
  const headerServiceOnlineHelp = useSettingItem('HEADER_SERVICE_ONLINE_HELP');

  const hasHeaderServices = menuItem.children.some((item) =>
    item.label.includes(HeaderVariables.Services)
  );
  const serviceOnline = menuItem.children.find((item) =>
    item.label.includes(HeaderVariables.ServiceOnline)
  );

  return (
    <Dropdown
      label={menuItem.label.replace(HeaderVariables.Service, '').trim()}
      link={menuItem.link ?? ''}
      isNewTab={menuItem.isNewTab}
    >
      {hasHeaderServices && headerServices && headerServices.length > 0 && (
        <Top>
          {headerServices.map(({ section, items }, index) => (
            <MenuColumn
              key={index}
              title={section ?? ''}
              menu={
                items && items.length !== 0
                  ? items.map(({ image, name, link, isNewTab }) => ({
                      image,
                      title: name ?? '',
                      link: link ?? '',
                      isNewTab,
                    }))
                  : []
              }
              columns={index === 0 ? 2 : 1}
            />
          ))}
        </Top>
      )}

      {serviceOnline && (
        <Bottom>
          <InfoLink
            label={serviceOnline.label
              .replace(HeaderVariables.ServiceOnline, '')
              .trim()}
            link={serviceOnline.link ?? ''}
            info={headerServiceOnlineHelp ?? ''}
            isNewTab={serviceOnline.isNewTab}
          />
        </Bottom>
      )}
    </Dropdown>
  );
}

export default ServiceDropdown;

const Top = styled.div`
  display: grid;
  grid-template-columns: 2.5fr 1fr 1fr;
  gap: 20px;
`;

const Bottom = styled.div`
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid ${colors.gray900};
`;
